import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import Col from 'components/Col';
import ValidationGroup from 'helpers/validation';
import PropTypes from 'prop-types';
import {inRange} from './helpers';
import {injectIntl, intlShape} from 'react-intl';

class Rectangle extends React.Component {
  static propTypes = {
    group: PropTypes.instanceOf(ValidationGroup).isRequired,
    intl: intlShape,
  };

  static initialState = {
    length: undefined,
    width: undefined,
  };

  state = Rectangle.initialState;

  update = ({key, value}) => {
    this.setState({[key]: parseFloat(value)});
  };

  volume = averageDepth => {
    return this.state.length * this.state.width * averageDepth * 7.5;
  };

  reset = () => {
    this.setState(Rectangle.initialState);
  };

  render() {
    const {formatMessage} = this.props.intl;

    return [
      <Col md={4} key='length-col'>
        <LayoutInput type='number'
                     dataKey='length'
                     step='0.01'
                     autoFocus
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.length.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.length'})}
                     dataChanged={this.update}
                     group={this.props.group}
                     validate={inRange}
                     value={this.state.length}
                     required />
      </Col>,
      <Col md={4} key='width-col'>
        <LayoutInput type='number'
                     dataKey='width'
                     step='0.01'
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.width.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.width'})}
                     group={this.props.group}
                     dataChanged={this.update}
                     validate={inRange}
                     value={this.state.width}
                     required />
      </Col>,
    ];
  }
}

export default injectIntl(Rectangle, {withRef: true});
